import { API_BASE } from "./Base";

export { API_BASE };

export const MenusAPI = new API_BASE("/Core/Menus");
export const LibraryAPI = new API_BASE("/Core/Library");
export const LibraryByParentIdAPI = new API_BASE("/Core/LibraryByParentId");
export const ContactAPI = new API_BASE("/Core/Contact");
export const ContactsAPI = new API_BASE("/Core/Contacts");
export const AppointmentsAPI = new API_BASE("/Core/Appointments");
export const AppointmentsByIDsAPI = new API_BASE("/Core/AppointmentsByIDs");
export const AppointmentsByDateAPI = new API_BASE("/Core/AppointmentsByDate");
export const RolesAPI = new API_BASE("/Administration/Roles");
export const RoleAPI = new API_BASE("/Administration/Role");
export const UpdateProfileAPI = new API_BASE("/Administration/UpdateProfile");
export const RolePermissionsAPI = new API_BASE(
  "/Administration/RolePermissions",
);
export const ForgetPasswordAPI = new API_BASE("/Authentication/Forgot");

export const FileUploadAPI = new API_BASE("/Emr/UploadFile");
export const PatientVisitAPI = new API_BASE("/Emr/PatientVisit");
export const PatientVisitsAPI = new API_BASE("/Emr/PatientVisits");

export const PrescriptionAPI = new API_BASE("/Emr/Prescription");
export const PrescriptionsAPI = new API_BASE("/Emr/Prescriptions");
export const LabTestAPI = new API_BASE("/Emr/LabTest");
export const LabTestsAPI = new API_BASE("/Emr/LabTests");

export const TicketsAPI = new API_BASE("/Emr/Tickets");
export const TicketAPI = new API_BASE("/Emr/Ticket");
export const GetNextTicketNumberAPI = new API_BASE("/Emr/GetNextTicketNumber");
